// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div style="position: relative;">
    <v-text-field prepend-icon="mdi-magnify" :label="$t('ui.skysource_search.search')" v-model="searchText" @keyup.native.esc="resetSearch()" hide-details single-line v-click-outside="resetSearch"></v-text-field>
    <v-list dense v-if="showList" two-line :style="listStyle" class="get-click" style="max-height: 260px; overflow: scroll; overflow-x: hidden;">
      <v-list-item v-for="source in autoCompleteChoices" :key="source.short_name" @click="sourceClicked(source)">
        <v-list-item-action>
          <img :src="iconForSkySource(source)"/>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ getName(source) }}</v-list-item-title>
          <v-list-item-subtitle>{{ getOrderOrType(source) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import swh from '@/assets/sw_helpers.js'
import ClickOutside from 'vue-click-outside'
import _ from 'lodash'
import { i18n } from '../plugins/i18n.js'

export default {
  data: function () {
    return {
      autoCompleteChoices: [],
      searchText: '',
      lastQuery: undefined
    }
  },
  props: ['value', 'floatingList'],
  watch: {
    searchText: function () {
      if (this.searchText === '') {
        this.autoCompleteChoices = []
        this.lastQuery = undefined
        return
      }
      this.refresh()
    }
  },
  computed: {
    listStyle: function () {
      return this.floatingList ? 'position: absolute; z-index: 1000; margin-top: 8px' : ''
    },
    showList: function () {
      return this.searchText !== ''
    }
  },
  methods: {
    sourceClicked: function (val) {
      this.$emit('input', val)
      this.resetSearch()
    },
    resetSearch: function () {
      this.searchText = ''
    },
    refresh: _.debounce(function () {
      var that = this
      let str = that.searchText
      let match = /(\d+h\d+m\d+(?:\.\d+)?\s+[+-]?\d+°\d+\'+\d+(?:\.\d+)?\'+)/gm.exec(str)
      if (match) {
        str = match[1]
      }
      str = str.replace(/'/gm, '\'\'')
      str = str.trim()
      if (str.match(/^#\d+$/gm)) {
        str = str.replace("#", "")
      }
      // str = str.toUpperCase()
      if (this.lastQuery === str) {
        return
      }
      this.lastQuery = str
      swh.querySkySources(str, 20).then(results => {
        if (str !== that.lastQuery) {
          console.log('Cancelled query: ' + str)
          return
        }
        that.autoCompleteChoices = results
      }, err => { console.log(err) })
    }, 200),
    getOrderOrType: function (s) {
      if (s.id) {
        return `#${s.id}`
      } else {
        if (!s) return i18n.t('ui.common.unknown')
        let morpho = ''
        if (s.model_data && s.model_data.morpho) {
          morpho = swh.nameForGalaxyMorpho(s.model_data.morpho)
          if (morpho) {
            morpho = morpho + ' '
          }
        }
        return morpho + swh.nameForSkySourceType(s.types[0])
      }
    },
    getName: function (s) {
      if (s.starname) {
        return s.starname
      } else {
        return s.short_name
      }
    },
    typeToName: function (t) {
      return swh.nameForSkySourceType(t)
    },
    iconForSkySource: function (s) {
      return swh.iconForSkySource(s)
    }
  },
  mounted: function () {
    var that = this
    const onClick = e => {
      if (that.searchText !== '') {
        that.searchText = ''
      }
    }
    const guiParent = document.querySelector('stel') || document.body
    guiParent.addEventListener('click', onClick, false)
  },
  directives: {
    ClickOutside
  }
}
</script>

<style>

</style>
